import React from 'react';
import PropTypes from 'prop-types';

import styles from './CategoryHeader.module.sass';

const CategoryHeader = ({ label, id, doFilterCategory, children }) => {
  return (
    <div>
      <div className={styles.header} onClick={() => doFilterCategory(id)}>
        {label}
      </div>
      <div>{children}</div>
    </div>
  );
};

CategoryHeader.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  doFilterCategory: PropTypes.func.isRequired,
  children: PropTypes.array,
};

export default CategoryHeader;
